import { Bridge } from '@mc/mc-jsbridge'

export const getUserInfo = () => {
  if (Bridge.prepared) {
    const { ret, data } = Bridge.getUserInfo()
    if (ret && data) {
      return data
    } else {
      return {}
    }
  } else {
    return {}
  }
}
